// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";


headerStyles.buttonSet = {
    css: css`
            justify-content: flex-end;
            flex-wrap: wrap;
            // removing styling objects from buttons b/c of not taking the proper css values issue
            button {
                ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                            width: 100%;
                            margin-left: 0 !important;
                            margin-bottom: 10px;
                        `,
                null,
                null,
                null,
                null,
            ])}
            }
            button + button {
                margin-left: 10px;
            }
        `,
    width: [12, 6, 6, 3, 3],
};
headerStyles.titleWrapper = {
    width: [12, 6, 6, 9, 9],
};
headerStyles.title = {
    variant: "h2",
    css: css`
            margin-bottom: 0;
        `,
};

